import React, { PropsWithChildren } from "react";
import {CssBaseline, makeStyles, Theme} from '@material-ui/core';
import NavigationSidebar from "./common/navigation/NavigationSidebar";
import PageHeader from "./common/PageHeader";
import SidebarButton from "./common/navigation/SidebarButton";
import {AuthorizedContext} from "../context/AuthorizedContext";
import Loader from "../components/core/Loader";
import {isEmpty} from 'lodash';
import DesktopFallbackDialog from "../components/core/DesktopFallbackDialog";

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        display: 'flex',
        flex: 1,
        flexDirection: "column"
    },
    content: {
        flexGrow: 1
    },
}));

type AuthenticatedUserLayoutProps = {
    pageTitle?: string
};

export const AuthenticatedUserLayout: React.FC<PropsWithChildren<AuthenticatedUserLayoutProps>> = ({pageTitle, children}) => {

    const classes = useStyles();
    const [open, setOpen] = React.useState(false);

    const {credentials} = React.useContext(AuthorizedContext);

    if (!credentials || isEmpty(credentials)) {
        return <Loader/>;
    }


    return (<div className={classes.root}>
            <CssBaseline/>
            <PageHeader pageTitle={pageTitle}>
                <SidebarButton open={open} setOpen={setOpen}/>
            </PageHeader>


            <main
                className={classes.content}
            >

                {children}

            </main>
            <NavigationSidebar open={open} setOpen={setOpen}/>
            <DesktopFallbackDialog/>
        </div>
    );


};

export default AuthenticatedUserLayout;
